CustomRenderMixin = require 'components/mixins/custom_render_mixin'
Importance = require 'components/etd/soj_importance'
Summary = require 'components/etd/soj_summary'
SummaryPrintout = require 'components/etd/soj_summary_printout'
SummaryOfJudgementSectionNameCell = require 'components/etd/soj_section_name_cell'
Translation = require 'components/mixins/translation'
{ clamp } = require 'lodash'

getCompleteOptionsList = (criterion, optionsLength, planetaryBoundariesIncluded) ->
  options = criterion.get 'options', Immutable.List()
  additionalOptions = criterion.get 'additionalOptions', Immutable.List()
  isOptionsListComplete = (options.size + additionalOptions.size) >= optionsLength
  completeOptionsList = if isOptionsListComplete
    options.concat additionalOptions
  else if planetaryBoundariesIncluded
    additionalOptions = additionalOptions.concat Immutable.fromJS(new Array(1)) # to avoid modifying original list
    noOfMissingOptions = optionsLength - options.size - additionalOptions.size - 2
    missingOptionsList = Immutable.fromJS(new Array(clamp(noOfMissingOptions, 0, 5)))
    options.concat missingOptionsList, additionalOptions
  else
    noOfMissingOptions = optionsLength - options.size - additionalOptions.size
    missingOptionsList = Immutable.fromJS(new Array(noOfMissingOptions))
    options.concat missingOptionsList, additionalOptions

SummaryOfJudgementsSection = createReactClass
  displayName: 'SojSectionComponent'
  mixins: [Translation('es:recommendations.table'), CustomRenderMixin]

  _getSojValueFor: (sectionName) ->
    if @props.isConsensus
      @props.section.get("#{sectionName}Consensus") or @props.section.get sectionName
     else
      @props.section.get sectionName

  _getSelectedOption: ->
    if @props.isConsensus
      @props.criterion.get('selectedOptionConsensus') or @props.criterion.get 'selectedOption'
    else
      @props.criterion.get 'selectedOption'

  render: ->
    {
      criterion
      criterionId
      editable
      isConsensus
      sectionKey
      optionsCount
      planetaryBoundariesIncluded
      renderMode
      section
      sectionHidden
    } = @props

    sectionName = section.get('name')
    importance = @_getSojValueFor 'importance'
    selectedOption = @_getSelectedOption()
    rowClassName = classNames _.string.dasherize(criterionId),
      'hidden-section': sectionHidden

    <tr className={rowClassName}>
      <SummaryOfJudgementSectionNameCell
        displayCellContent={not sectionHidden or renderMode is 'printout'}
        renderMode={renderMode}
        sectionHidden={sectionHidden}
        sectionName={sectionName}
        onHideSection={@props.onHideSection}
      />
      {
        if renderMode is 'printout'
          completeList = getCompleteOptionsList criterion, optionsCount, planetaryBoundariesIncluded
          completeList.map (option, key) ->
            isChecked = selectedOption is option?.get 'value'
            <SummaryPrintout
              index={key}
              criterionId={criterionId}
              option={option}
              isChecked={isChecked}
              key={key}
              planetaryBoundariesIncluded={planetaryBoundariesIncluded}
            />
          .toList()
        else
          <Summary
            criterion={criterion}
            hidden={sectionHidden}
            selectedOption={selectedOption}
          />
      }
      {
        unless renderMode is 'printout'
          <Importance
            editable={editable}
            hidden={sectionHidden}
            isConsensus={isConsensus}
            value={importance}
            sectionKey={sectionKey}
            sectionName={sectionName}
          />
      }
    </tr>

module.exports = SummaryOfJudgementsSection
